export default "__VITE_ASSET__d46fff6f__"